import {axios} from '../../../lib'

export const getLastOMCSyncLog = () => {
    return axios.get('/stats/omc-logs/last')
}
